import { render, staticRenderFns } from "./uboList.vue?vue&type=template&id=12525953&scoped=true&"
import script from "./uboList.vue?vue&type=script&lang=js&"
export * from "./uboList.vue?vue&type=script&lang=js&"
import style0 from "./uboList.vue?vue&type=style&index=0&id=12525953&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12525953",
  null
  
)

export default component.exports